"use client";

import Image from "next/image";
import React from "react";
import {
  LOGO_ASSETS,
  LOGO_SIZE_MAP,
  LogoSize,
  LogoVariant,
} from "@/constants/brand";

export interface LogoProps {
  className?: string;
  variant?: LogoVariant; // flat or square
  size?: LogoSize; // sm, md, lg, xl
  priority?: boolean;
  ariaLabel?: string;
}

export default function Logo({
  className = "",
  variant = "flat",
  size = "md",
  priority = false,
  ariaLabel,
}: LogoProps) {
  const asset = LOGO_ASSETS[variant];
  const { width, height } = LOGO_SIZE_MAP[variant][size];

  return (
    <Image
      src={asset.src}
      alt={ariaLabel || asset.alt}
      width={width}
      height={height}
      priority={priority}
      className={className}
      style={{ width: "auto", height: "auto" }}
      unoptimized // SVG logos don't benefit from optimization
    />
  );
}
